<template>

<div class=" colapsables">
    <div class="block-edit-header">
        <img v-if="editCual.dragIcon"
             :src="require('@/assets/images/blocks/modulo_'+editCual.dragIcon+'.svg')"
             class="block-edit-icon" />
        <img v-else-if="editCual.compo === 'editPremio'"
             :src="require('@/assets/images/blocks/modulo_Reward.svg')"
             class="block-edit-icon" />
        <img v-else-if="editCual.compo === 'editBeneficio'"
             :src="require('@/assets/images/blocks/modulo_Benefit.svg')"
             class="block-edit-icon" />
        <img v-else
             :src="require('@/assets/images/blocks/modulo_'+editCual.compo.replace('edit','')+'.svg')"
             class="block-edit-icon" />
        <span class="block-edit-name">{{ editCual.dragLabel || editCual.nombre || editCual.compo.replace('edit','') }}</span>
    </div>
    <component  :is="editCual.compo"  :value="editCual" @input="onChildInput" :key="editCual.index+$store.state.mainComp"></component>

    <hr  class="separator mt10 mb10">
    <div  class="edicion_block" >
      <a @click="switchSobreBackground()" class="btn btn-info btn-initial text-uppercase mb20"  > {{$t('general.cerrareditor')}}</a>
    </div>

</div>
</template>



<script>


//Edits
import editBoton from './dragndrop/editBoton'
import editHTML from './dragndrop/editHTML'
import editLine from './dragndrop/editLine'
import editParrafo_new from './dragndrop/editParrafo'
import editParrafo from './dragndrop/editParrafo'
import editTitulo from './dragndrop/editTitulo'
import editPremio from './dragndrop/editPremio'
import editBeneficio from './dragndrop/editBeneficio'
import editEmpty from './dragndrop/editEmpty'
import editSpace from './dragndrop/editSpace'
import editImagen from './dragndrop/editImagen'
import editVideo from './dragndrop/editVideo'
import editUbicacion from './dragndrop/editUbicacion'
import editSocial from './dragndrop/editSocial'
import editAvatar from './dragndrop/editAvatar'
import editQRCode from '@/components/blocks/qrcode/settings.vue'
import editIcon from '@/components/blocks/icon/settings.vue'
import editSaveDate from '@/components/blocks/saveDate/settings.vue'
import editFlags from '@/components/blocks/flags/settings.vue'
import editLeads from '@/components/blocks/leads/settings.vue'




export default {
    props:['editcual'],
    data(){
        return{
            cardVal:this.$store.getters.editingLinckard,
            editCual:this.editcual,
        }
    },
    methods:{
        switchSobreBackground(){
            this.$util.closeAllDivs();
            this.$bus.$emit("switchCompSobre", 'leftColSobreA');
        },
        onChildInput(updatedValue) {
            this.editCual = { ...this.editCual, ...updatedValue };
            
            let currentCard = this.$store.getters.editingLinckard;
            
            let updatedCard = { ...currentCard };
            if (updatedCard.sobredrags) {
                updatedCard.sobredrags = [...updatedCard.sobredrags];
                
                if (updatedValue.arrayPosition !== undefined && updatedCard.sobredrags[updatedValue.arrayPosition]) {
                    updatedCard.sobredrags[updatedValue.arrayPosition] = { ...updatedValue };
                    this.$store.commit('changeActiveEdit', updatedCard);
                }
            }
        }
    },
    components: {
        'editUbicacion':editUbicacion,
        'editAvatar':editAvatar,
        'editSocial':editSocial,
        'editVideo':editVideo,
        'editImagen':editImagen,
        'editTitulo':editTitulo,
        'editPremio':editPremio,
        'editBeneficio':editBeneficio,
        'editParrafo':editParrafo,
        'editHTML':editHTML,
        'editLine':editLine,
        'editSpace':editSpace,
        'editBoton':editBoton,
        'editEmpty':editEmpty,
        'editParrafo_new':editParrafo_new,
        editQRCode, 
        editIcon, 
        editSaveDate,
        editFlags, 
        editLeads,
    }
}


</script>

<style scoped>
.btn-initial:hover{
    color:white !important;
}
.edicion_block a{
    color:white ;
}
.block-edit-header {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px 15px;
    background: #fff;
    border-bottom: 1px solid #efefef;
}
.block-edit-icon {
    width: 48px;
    height: 48px;
    object-fit: contain;
    flex-shrink: 0;
    background: #f4f4f4;
    border-radius: 8px;
    padding: 6px;
}
.block-edit-name {
    font-size: 13px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #333;
}
</style>
